import React from 'react';
import { useNavigate } from 'react-router-dom';
import { OrderDetailsForDisplay } from '@/types/order.types';
import { Button } from 'components/ui/button';

export const OrderSummaryCard = ({ 
    orderDetails, 
    hideEditButton = false,
    couponCode = null,
    discountAmount = null
}: { 
    orderDetails: OrderDetailsForDisplay | null;
    hideEditButton?: boolean;
    couponCode?: string | null;
    discountAmount?: number | null;
}) => {
    const navigate = useNavigate();

    if (!orderDetails) {
        return (
            <div className="bg-white p-6 rounded-xl shadow-md border">
                <p>Sipariş özeti yükleniyor...</p>
            </div>
        );
    }

    return (
        <div className="bg-white p-6 rounded-xl shadow-md border sticky top-24">
            <h3 className="text-xl font-bold text-gray-800 mb-4">Sipariş Özeti</h3>
            <div className="space-y-2 text-gray-600">
                <div className="flex justify-between"><span>Paket: <strong>{orderDetails.packageName}</strong></span><span>₺{orderDetails.packagePrice.toFixed(2)}</span></div>
                
                {orderDetails.items.filter(item => item.name !== orderDetails.packageName).map(item => (
                    <div key={item.name} className="flex justify-between">
                        <span>{item.name} x {item.quantity}</span>
                        <span>₺{item.subtotal.toFixed(2)}</span>
                    </div>
                ))}

                {orderDetails.shippingFee !== undefined && (
                    <div className="flex justify-between">
                        <span>Kargo Ücreti</span>
                        <span className={orderDetails.shippingFee > 0 ? 'text-gray-800 font-medium' : 'text-emerald-600 font-semibold'}>
                            {orderDetails.shippingFee > 0 ? `₺${orderDetails.shippingFee.toFixed(2)}` : 'Ücretsiz'}
                        </span>
                    </div>
                )}
                
                <hr className="my-2" />
                
                {couponCode && discountAmount ? (
                    <>
                        <div className="flex justify-between font-bold text-gray-500 line-through">
                            <span>Ara Toplam</span>
                            <span>₺{orderDetails.total.toFixed(2)}</span>
                        </div>
                        <div className="flex justify-between font-bold text-emerald-600">
                            <span>İndirim ({couponCode})</span>
                            <span>-₺{discountAmount.toFixed(2)}</span>
                        </div>
                        <hr className="my-2" />
                        <div className="flex justify-between font-extrabold text-xl text-gray-800">
                            <span>Genel Toplam</span>
                            <span className="text-rose-600">₺{Math.max(0, orderDetails.total - discountAmount).toFixed(2)}</span>
                        </div>
                    </>
                ) : (
                    <div className="flex justify-between font-bold text-lg text-gray-800">
                        <span>Toplam Tutar</span>
                        <span className="text-rose-600">₺{orderDetails.total.toFixed(2)}</span>
                    </div>
                )}
                
                {/* YENİ: Eğer hideEditButton true değilse butonu göster */}
                {!hideEditButton && (
                    <Button variant="outline" className="w-full mt-6" onClick={() => navigate('/baski')}>
                        Adetleri Düzenle
                    </Button>
                )}
            </div>
        </div>
    );
};